import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useAsignatures } from '../asginatures/Asignatures';
import { useInstitutions } from '../institutions/Institutions';
import { useSeries } from '../series/Series';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
  },
}));

function useForm(e) {
  const [entries, setEntries] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/teachers/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setEntries({ ...data?.data, ...data?.data?.details });
      })
      .catch((error) => {
        console.error(error);
      });
  }, [id]);

  function handleChange(e) {
    let { name, value } = e.target;
    if (value.includes('{') && value.includes('}')) {
      value = JSON.parse(value);
    }
    setEntries({ ...entries, [name]: value });
  }

  return {
    handleChange,
    entries,
  };
}

export function UpdateTeacher(props) {
  const { asignatures } = useAsignatures();
  const { series } = useSeries();
  const { institutions } = useInstitutions();
  const { entries, handleChange } = useForm();
  const classes = useStyles();
  const navigate = useNavigate();

  const handleUpdate = async () => {
    try {
      const { _id, ...data } = entries;
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/teachers/${_id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
      );
      let result = await response.json();
      if (result.success === true) {
        navigate('/admin/teachers', { replace: true });
      } else {
        console.error(result.message);
        window.alert('Error al actualizar el docente, intente de nuevo');
      }
    } catch (err) {
      console.error(err);
      window.alert('Error al actualizar el docente, intente de nuevo');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás actualizar un nuevo
        docente para la plataforma, asignandole la institución, asignaturas y
        series que imparte para una correcta configuración.
      </p>
      <div
        style={{
          width: '100%',
          paddingLeft: '20px',
          paddingRight: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <TextField
          className={classes.input}
          label="Correo"
          variant="outlined"
          name="email"
          value={entries?.email || ''}
          onChange={handleChange}
          type={'email'}
        />
        <TextField
          className={classes.input}
          label="Contraseña"
          variant="outlined"
          name="password"
          value={entries?.password || ''}
          onChange={handleChange}
          type={'password'}
        />
        <TextField
          className={classes.input}
          label="Nombre"
          variant="outlined"
          name="name"
          value={entries?.name || ''}
          onChange={handleChange}
        />
        <TextField
          className={classes.input}
          label="Apellido"
          variant="outlined"
          name="lastName"
          value={entries?.lastName || ''}
          onChange={handleChange}
        />
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-asignatures-label">Asignaturas</InputLabel>
          <Select
            labelId="select-asignatures-label"
            id="select-asignatures"
            name="asignatures"
            value={
              entries?.asignatures?.map((asig) => {
                if (asig?._id) {
                  return asig?._id;
                }
                return asig;
              }) || []
            }
            onChange={handleChange}
            multiple
            label={'Asignaturas'}
          >
            {asignatures.map((asignature) => (
              <MenuItem value={asignature?._id}>{asignature?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-series-label">Series</InputLabel>
          <Select
            labelId="select-series-label"
            id="select-series"
            name="series"
            value={
              entries?.series?.map((serie) => {
                if (serie?._id) {
                  return serie?._id;
                }
                return serie;
              }) || []
            }
            onChange={handleChange}
            multiple
            label={'Series'}
          >
            {series.map((serie) => (
              <MenuItem value={serie?._id}>{serie?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-institutions-label">Institución</InputLabel>
          <Select
            labelId="select-institutions-label"
            id="select-institutions"
            name="institution"
            value={entries?.institution?._id || entries?.institution || ''}
            onChange={handleChange}
            label={'Institución'}
          >
            {institutions.map((institution) => (
              <MenuItem value={institution?._id}>{institution?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={handleUpdate}
          className={classes.input}
          variant="contained"
          color="primary"
          disabled={
            !entries?.name ||
            !entries?.lastName ||
            !entries?.asignatures ||
            !entries?.series ||
            !entries?.institution
          }
        >
          Actualizar
        </Button>
      </div>
    </div>
  );
}
